'use strict';

import { Component } from 'react';
import { openModalWindow, closeModalWindow } from '../App/actions'

export class FwScene extends Component {

	openModal = (obj) => {
    obj.opened = true;
    this.props.dispatch(openModalWindow(obj));
  }

  closeModal = () => {
    this.props.dispatch(closeModalWindow());
  }
}


// WEBPACK FOOTER //
// ./src/containers/scenes/FwScene.js